import React from 'react';
import classNames from 'classnames';
import css from './hot-project.module.less';

export const HotProject =(props)=>{
    const {items=[],goDetail} = props;
    return (
        <div className={ css.list }>
            <div className={ classNames(css.item,css.tableTitle) } >
                <div className={ css.order }>排名</div>
                <div className={ css.title }>名称</div>
                <div className={ css.viewCount }>浏览量</div>
            </div>
            {
                items.map((opt,index)=>
                    <div className={ css.item } key={ index } onClick={()=>{goDetail(opt)}}>
                        <div className={ css.order }>
                            <em className={ index<3?css.active:'' }>{ index+1 }</em>
                        </div>
                        <div className={ css.title }>{ opt.project_name }</div>
                        <div className={ css.viewCount }>{ opt.read_num }</div>
                    </div>
                )
            }
        </div>
    );
}